@if (container$ | async; as container) {
	<stages-association-list
		[associationStore]="associationStore"
		[groups]="asArray(container.associationGroups)"
		[messageKeyNone]="messageKeyNone"
		[editable]="editable"
		[showEmptyGroups]="showEmptyGroups"
		[allowCreateElements]="false"
		[class]="classes"
		[container]="$any(container)"
		(openBrowse)="openBrowse($any($event))"
		[showProcessInterfaceName]="false"
	/>
}
